import { ResponsiveContrastSensitivityResults } from './ContrastSensitivity';
import {
  ResponsiveCalibrationSelectionContainer,
  ResponsiveScreenCalibrationContainer,
  ResponsiveCameraCalibrationOpticianContainer,
  ResponsiveSetDistanceContainer,
  ResponsiveCompletedTests,
  ResponsiveTestContainer,
  ResponsiveAcuityResults,
} from '.';
import { ResponsiveRefractionResults } from './Refraction';
import { ResponsiveRefractionTwoResults } from './RefractionTwo';

const ResponsiveContentOptician = ({
  setTitle,
  calibrationStep,
  setCalibrationStep,
  activeTab,
  setActiveTab,
  patientResponse,
  visualFieldUpdate,
  isTestInProgress,
}) => {
  const contentOptions = [
    {
      id: 'calibration-selection',
      content: <ResponsiveCalibrationSelectionContainer setActiveTab={setActiveTab} />,
    },
    {
      id: 'screen-calibration',
      content: (
        <ResponsiveScreenCalibrationContainer
          calibrationStep={calibrationStep}
          setCalibrationStep={setCalibrationStep}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      ),
    },
    {
      id: 'camera-calibration',
      content: <ResponsiveCameraCalibrationOpticianContainer setActiveTab={setActiveTab} />,
    },
    {
      id: 'set-distance',
      content: <ResponsiveSetDistanceContainer setActiveTab={setActiveTab} />,
    },
    {
      id: 'test',
      content: (
        <ResponsiveTestContainer
          setActiveTab={setActiveTab}
          setTitle={setTitle}
          patientResponse={patientResponse}
          visualFieldUpdate={visualFieldUpdate}
          isTestInProgress={isTestInProgress}
        />
      ),
    },
    {
      id: 'results',
      content: <ResponsiveCompletedTests setActiveTab={setActiveTab} />,
    },
    {
      id: 'completedTests',
      content: <ResponsiveAcuityResults goBackToCompletedTests={() => setActiveTab('results')} />,
    },
    {
      id: 'contrastSensitivityResults',
      content: <ResponsiveContrastSensitivityResults goBackToCompletedTests={() => setActiveTab('results')} />,
    },
    {
      id: 'completedTestRefraction',
      content: <ResponsiveRefractionResults goBackToCompletedTests={() => setActiveTab('results')} />,
    },
    {
      id: 'completedTestRefractionTwo',
      content: <ResponsiveRefractionTwoResults goBackToCompletedTests={() => setActiveTab('results')} />,
    },
  ];

  const selectedContent = contentOptions.find((selectedTab) => {
    return activeTab === selectedTab.id;
  });

  return selectedContent?.content;
};

export default ResponsiveContentOptician;
